// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"d8664aea","977":"bdb3d37c"}[chunkId] + ".chunk.js";
};